import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, stagger, item } from "@/components/site/Reveal";
import { SERVICES, waLink, onWhatsApp } from "@/lib/site";

const Card = ({ s, big }) => (
  <motion.a
    variants={item}
    href={waLink(`Preciso de: ${s.title}.`)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`service-${s.id}`}
    onClick={() => onWhatsApp(`service-${s.id}`)}
    className={`group relative overflow-hidden rounded-sm border border-white/10 hover:border-brand transition-colors ${
      big ? "lg:row-span-2 min-h-[280px] lg:min-h-[560px]" : "min-h-[260px]"
    }`}
  >
    <img
      src={s.img}
      alt={s.alt}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
    <div className="relative h-full flex flex-col justify-end p-6">
      <div className="absolute top-5 right-5 h-10 w-10 grid place-items-center rounded-sm bg-white/10 backdrop-blur border border-white/20 group-hover:bg-brand transition-colors">
        <ArrowUpRight className="h-5 w-5 text-white" />
      </div>
      <h3 className={`font-display font-black text-white leading-none ${big ? "text-3xl md:text-4xl" : "text-2xl"}`}>
        {s.title}
      </h3>
      <p className="mt-2 text-sm text-zinc-300 max-w-md">{s.desc}</p>
    </div>
  </motion.a>
);

export const Services = () => {
  const [carros, motos, reboque, transporte, emergencial] = SERVICES;
  return (
    <section id="servicos" className="relative py-24 md:py-32 bg-surface border-y border-white/10">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <span className="text-brand font-display text-lg font-bold uppercase tracking-[0.2em]">Nossos Serviços</span>
          <h2 className="mt-3 font-display text-4xl md:text-6xl font-black text-white leading-[0.92]">
            Soluções completas em guincho
          </h2>
          <p className="mt-5 text-lg text-zinc-400">
            Remoção e transporte de veículos com segurança e responsabilidade em Jundiaí e região.
          </p>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          <Card s={carros} big />
          <Card s={motos} />
          <Card s={reboque} />
          <Card s={transporte} />
          <Card s={emergencial} />
        </motion.div>
      </div>
    </section>
  );
};
